import React from 'react';
import {Container, Row, Col,Form, FormGroup, Modal, Input,Button,ModalBody,ModalHeader,ModalFooter} from 'reactstrap';
import Axios from 'axios';
import Config from '../../Core/Config.js';
import { framework, ui } from 'saffroncodejs';
import UserManager from '../../Core/UserManager';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/fontawesome-free-solid';
import FileBase64 from 'react-file-base64';
import './Profile.css';
var PageManager = framework.PageManager;
var UpdateUserModel={
    UserId:"",
    FirstName:"",
    LastName:"",
    EMailAddress:"",
    CityId:"",
    Adress:"",
    MobileNo:"",
    UserName:"",
    Password:"",
    OldPassword:"",
    BirthDate:"",
    GenderTypeBaseId:"",
    PostalCode:"",
    Description:""
} 
var UpdatePhotoUserModel={
    UserId:"",
    UserPhoto:""
}
var $ = require('jquery'); 
class Profile extends React.Component {
    constructor(props) 
    {
        super(props);
        this.setJob = this.setJob.bind(this);
        this.setPassword=this.setPassword.bind(this);
        this.state = {
            isLoading: true,
            userProfileInfo:[],
            job:'',
            photoSrc:'',
            password:'',
            modal: false,
            file: '',
            imagePreviewUrl: '',
            files: [],
        }
        this.toggle = this.toggle.bind(this);
        this.updateUserPhoto=this.updateUserPhoto.bind(this);
        this.state.userProfileInfo = [];
        this.loadDetail(); 
        
        $('#uploadimg>input').addClass('fileInput');
    }
    
   /*******************************GetUsersProfile********************************** */
    loadDetail(){
        Axios.get(Config.domain_pic + "/GetUsersProfile?" +
            "LanguageBaseId=" + 11 + "&UserId=" + UserManager.getUserToken()+ "&OtherUserId=" +UserManager.getUserToken()
        )
            .then((result) => {
                this.setState({ userProfileInfo: result.data, isLoading: false });
            })
            .catch((error) => {
                alert(error) 
            })
    }
    /*****************************setJob****************************** */
    setJob(event){
        this.setState({
            job:event.target.value
        })
        $('#password').addClass('pass_line');
        $('#password').removeClass('pass_redline');
        $('#pass-error').addClass('dnone');
        $('#pass-error').removeClass('dblock');
        $('#success_update').addClass('success_update_none');
        $('#success_update').removeClass('success_update_block');
    }
    /**********************updateProfileData***************************** */
    updateProfileData(UId,FName,LName,EAddress,CId,Ad,MNo,UName,Pass,OPass,BDate,GTypeBaseId,PCode){
        if(Pass ===""){
           $('#password').addClass('pass_redline');
           $('#password').removeClass('pass_line');
        //    document.querySelectorAll('[id^="password"]').addClass('pass_redline');
        //    document.querySelectorAll('[id^="password"]').removeClass('pass_line');
        }
        else{
            UpdateUserModel.UserId=UId;
            UpdateUserModel.FirstName=FName;
            UpdateUserModel.LastName=LName;
            UpdateUserModel.EMailAddress=EAddress;
            UpdateUserModel.CityId=CId;
            UpdateUserModel.Adress=Ad;
            UpdateUserModel.MobileNo=MNo;
            UpdateUserModel.UserName=UName;
            UpdateUserModel.Password=Pass;
            UpdateUserModel.OldPassword=OPass;
            UpdateUserModel.BirthDate=BDate;
            UpdateUserModel.GenderTypeBaseId=GTypeBaseId;
            UpdateUserModel.PostalCode=PCode;
            UpdateUserModel.Description=this.state.job;
            Axios.post(Config.domain_pic + "/UpdateUser",UpdateUserModel)         
            
                .then((result) => {
                    // console.log("result.userprofile: ", JSON.stringify(result.data));
                    if(result.data==="-5"){
                        $('#pass-error').addClass('dblock');
                        $('#pass-error').removeClass('dnone');
                        $('#success_update').addClass('success_update_none');
                        $('#success_update').removeClass('success_update_block');
                    }
                    else{
                        $('#success_update').addClass('success_update_block');
                        $('#success_update').removeClass('success_update_none');
                    }
                })
                .catch((error) => {
                    alert(error) 
                })
        }
    }
    /****************setPassword****************** */
    setPassword(event){
        this.setState({
            password:event.target.value
        });
           $('#password').addClass('pass_line');
           $('#password').removeClass('pass_redline');
           $('#pass-error').addClass('dnone');
           $('#pass-error').removeClass('dblock');
           $('#success_update').addClass('success_update_none');
           $('#success_update').removeClass('success_update_block');
    }
    /******************UploadImage********************* */
    toggle() {
        this.setState({
          modal: !this.state.modal
        });
      }
      _handleSubmit(e) {
        e.preventDefault();
        // TODO: do something with -> this.state.file
      }

      getFiles(files){
        this.setState({ files: files })
        // console.log(files);
      }

      _handleImageChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          this.setState({
            file: file,
            imagePreviewUrl: reader.result
          });
        }
  
        reader.readAsDataURL(file)
      }

      /****************updateUserPhoto**************** */
      updateUserPhoto(UId,UPhoto){
        UpdatePhotoUserModel.UserId=UId;
        UpdatePhotoUserModel.UserPhoto=UPhoto;
        Axios.post(Config.domain_pic + "/UpdateUserPhoto",UpdatePhotoUserModel)         
        
            .then((result) => {
                if(result.data==="-5"){
                    $('#pass-error').addClass('dblock');
                    $('#pass-error').removeClass('dnone');
                    $('#success_update').addClass('success_update_none');
                    $('#success_update').removeClass('success_update_block');
                }
                else{
                    $('#success_update').addClass('success_update_block');
                    $('#success_update').removeClass('success_update_none');
                }
            })
            .catch((error) => {
                alert(error) 
            })  
      }

      /**************************************************************************** */
    render() {
        let {imagePreviewUrl} = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img src={imagePreviewUrl} alt="default"/>);
        } else {
            $imagePreview = (<div className="previewText">لطفا عکس پروفایل خود را انتخاب نمایید</div>);
        }
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>حساب کاربری</h4>
                    </Col>
                </Row>
                <br />
                <Container>
                    
                    {!this.state.isLoading ? 
                        
                        this.state.userProfileInfo.slice(0,1).map((p)=>
                            <Row className="profile">
                                <Col sm='12' md='3'>
                                    <div className="profile_image">
                                        <img src={'http://mobapp.novininsurance.com/UploadImages/UserProfile/'+p.PhotoName+'.jpg'} alt={p.UserName}  />
                                        <div className="edit_mage" onClick={this.toggle} style={{display:'none'}}><FontAwesomeIcon icon={faEdit} className="edit_img" /></div>
                                        <Modal isOpen={this.state.modal} modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }} toggle={this.toggle} className="alert_phishnahadha">
                                            <ModalHeader toggle={this.toggle}></ModalHeader>
                                            <ModalBody>
                                                <div className="previewComponent">
                                                    <form onSubmit={(e)=>this._handleSubmit(e)}>
                                                    <label id="uploadimg" class="uploadimg">
                                                        <FileBase64 multiple={ false }
                                                            onDone={ this.getFiles.bind(this)}   name="manifest_file_import"
                                                        type="file"
                                                        onChange={(e)=>this._handleImageChange(e)}  />
                                                        </label>
                                                        {/* <button className="submitButton"
                                                        type="submit"
                                                        onClick={(e)=>this._handleSubmit(e)}>بارگذاری عکس</button>  */}
                                                    </form>
                                                    <div className="imgPreview">
                                                        {$imagePreview}
                                                    </div>
                                                </div>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="primary" onClick={()=>{this.updateUserPhoto(p.UserId,this.state.files.base64)}}>ذخیره</Button>{' '}
                                                <Button color="secondary" onClick={this.toggle}>انصراف</Button>
                                            </ModalFooter>
                                        </Modal>   
                                        </div>    
                                </Col>
                                <Col sm='12' md='9'>
                                    <Row>
                                        <Col sm='12' className="row_profile_info">
                                            <Row>
                                                <Col sm='12' md='6' className="titel_box">نام کاربری :</Col>
                                                <Col sm='12' md='6' className="content_bx">{p.UserName}</Col>
                                            </Row>
                                        </Col>
                                        <Col sm='12' className="row_profile_info">
                                            <Row>
                                                <Col sm='12' md='6' className="titel_box">ایمیل : </Col>
                                                <Col sm='12' md='6' className="content_bx">{p.EMailAddress}</Col>
                                            </Row>
                                        </Col>
                                        <Col sm='12' className="row_profile_info">
                                            <Row>
                                                <Col sm='12' md='6' className="titel_box">جنسیت : </Col>
                                                <Col sm='12' md='6' className="content_bx">{p.GenderTypeBaseId===32?"خانم": "آقا"}</Col>
                                            </Row>
                                        </Col>
                                        <Col sm='12' className="row_profile_info">
                                            <Row>
                                                <Col sm='12' md='6' className="titel_box">رمز عبور : </Col>
                                                <Col sm='12' md='6' className="content_bx">
                                                    <Form>
                                                        <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                                            <Input type="password" name="password" id="password" value={this.state.password} onChange={this.setPassword} className="pass_line"  />
                                                            <div id="pass-error" className="dnone">رمز عبور اشتباه است</div>
                                                        </FormGroup>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm='12' className="row_profile_info">
                                            <Row>
                                                <Col sm='12' md='6' className="titel_box">شغل : </Col>
                                                <Col sm='12' md='6' className="content_bx">
                                                    <Form>
                                                        <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                                                                <Input type="select" name="select1" id="paymentSelect" value={this.state.job} onChange={this.setJob}>
                                                                    <option >{p.Description}</option>
                                                                    <option value="حقوق بگیر">حقوق بگیر</option>
                                                                    <option value="خانه دار">خانه دار</option>
                                                                    <option value="دانش آموز">دانش آموز</option>
                                                                    <option value="دانشجو">دانشجو</option>
                                                                    <option value="سرباز">سرباز</option>
                                                                    <option value="صاحب کسب و کار">صاحب کسب و کار</option>
                                                                    <option value="فاقد شغل">فاقد شغل</option>
                                                                </Input>
                                                        </FormGroup>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                        <div id="success_update" className="success_update_none ">اطلاعات حساب کاربری شما با موفقیت ویرایش شد</div>
                                        <div className="buttons">
                                            <Button onClick={()=>{this.updateProfileData(p.UserId,p.FirstName,p.LastName,p.EMailAddress,p.CityId,p.Adress,p.MobileNo,p.UserName,this.state.password,this.state.password,p.BirthDate,p.GenderTypeBaseId,p.PostalCode)}}>
                                                ذخیره
                                            </Button> &nbsp;
                                            <Button onClick={()=>{PageManager.changePage(Config.p_changepassword)}} >
                                                تغییر رمز عبور
                                            </Button>
                                        </div>
                                        </Col>
                                    </Row>
                                </Col>
                                </Row>
                                )
                        
                        : (<ui.Preloader />)}
                       
                    </Container>
                <br />
            </div>
        );
    }
}
export default Profile;


// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js